<template>
  <form method="POST" id="contact-form" @submit.prevent="formController()">
    <div class="input-box">
      <label>Razón Social</label>
      <input
        type="text"
        name="business_name"
        id="business_name"
        v-model="model.business_name"
      />
    </div>

    <div class="input-box">
      <label>RUC</label>
      <input type="text" name="ruc" id="ruc" v-model="model.ruc" />
    </div>

    <div class="input-box">
      <label>Nombre completo</label>
      <input
        type="text"
        name="full_name"
        id="full_name"
        v-model="model.full_name"
      />
    </div>

    <div class="input-box">
      <label>Teléfono</label>
      <input
        type="tel"
        name="phone_number"
        id="phone_number"
        v-model="model.phone_number"
      />
    </div>

    <div class="input-box">
      <label>Email</label>
      <input type="email" name="email" id="email" v-model="model.email" />
    </div>

    <div class="input-box input-box--textarea">
      <label>Mensaje</label>
      <textarea
        name="message"
        id="message"
        cols="30"
        rows="10"
        v-model="model.message"
      ></textarea>
    </div>
    <div class="input-buttons">
      <button type="submit" class="btn btn--green">Enviar solicitud</button>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import { inject, ref } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'

export default {
  props: {
    url_send_form: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const loading = inject('loading')
    const model = ref({
      business_name: '',
      ruc: '',
      full_name: '',
      phone_number: '',
      email: '',
      message: '',
    })

    const formController = async () => {
      loading.value = true

      try {
        const form = document.getElementById('contact-form')
        const formData = new FormData(form)

        const { data } = await axios.request({
          url: props.url_send_form,
          method: 'POST',
          data: formData,
        })

        if (data.fb_pixel_data) {
          fbq(
            'track',
            data.fb_pixel_data.event_name,
            {},
            {
              eventID: data.fb_pixel_data.event_id,
            }
          )
        }

        loading.value = false
        customAlert(data)

        model.value = {
          business_name: '',
          ruc: '',
          full_name: '',
          phone_number: '',
          email: '',
          message: '',
        }
      } catch (error) {
        loading.value = false
        console.error(error)
      }
    }

    return {
      model,
      formController,
    }
  },
}
</script>
